(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('WebhookStatusService', WebhookStatusService);

    WebhookStatusService.$inject = ['WebhookStatusFactory'];

    function WebhookStatusService(WebhookStatusFactory) {
        var service = {
            getErrorStatus: getErrorStatus
        };

        return service;

        function getErrorStatus() {
            return WebhookStatusFactory.getErrorStatus().$promise;
        }
    }
})();
